
import pzBadge from '@/components/pzBadge'
export default {
    components: {
        pzBadge
    },
    props: {
        /**
         * tabs 数据
         */
        list: {
            type: Array,
            require: true,
            default: []
        },
        /**
         * tabs 当前选中值
         */
        value: {
            type: [String, Number],
            require: true
        }
    },
    data() {
        return {
            children: [],
            childrenCheck: ''
        }
    },
    watch: {},
    methods: {
        /**
         * tabs 切换事件
         */
        handleClick(e) {
            // 防止重复赋值导致的业务逻辑异常
            if (this.value === e.name) return
            // 查看是否有子级
            const children = this.list.find(item => item.name === e.name)?.children
            // 如果有子级就选择第一个
            if (children) {
                this.childrenCheck = children[0].name
                this.children = children
            } else {
                this.childrenCheck = ''
                this.children = []
            }
            this.$emit('change', e)
            this.$emit('input', e.name)
        },
        /**
         * 子级切换事件
         */
        onChangeChildren(vo) {
            if (this.childrenCheck === vo.name) return
            this.childrenCheck = vo.name
            this.$emit('onChangeChildren', vo)
        }
    }
}
